<template>
<section id="page-social-links">
  <div class="container">
    <div class="row">
      <clearfix :biggest="true" :bootstrap="true"></clearfix>

      <div class="col-sm-6">
        <div class="home-button home-media-button" @click="this.window.open('https://twitter.com/0xCBEE', '_blank')">
          <icon name="twitter" scale="5"></icon><br>&nbsp;<br>
          TWITTER
        </div>
      </div>

      <div class="col-sm-6">
        <div class="home-button home-media-button" @click="this.window.open('https://linkedin.com/in/stonavsky', '_blank')">
          <icon name="linkedin" scale="5"></icon><br>&nbsp;<br>
          LINKEDIN
        </div>
      </div>
    </div>

    <clearfix :biggest="true"></clearfix>

  </div>
</section>
</template>

<script>
  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon.vue'
  import Clearfix from '@/components/utils/Clearfix'

  export default {
    components: { Clearfix, Icon }
  }
</script>

<style>
  #page-social-links {
    background: url('../../assets/img/bg/pattern.jpg') 50% 0 fixed;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// SocialLinks.vue?3f4507e8